import _ from 'lodash';
import numeral from 'numeral';
import { textFilter } from 'react-bootstrap-table2-filter';

const memFunc = (...args) => JSON.stringify([...args]);

const COLUMN_FORMATTERS = {
  balanceDue: (v) => numeral(v).format('$0,0.00'),
};

export const collectColumnNames = _.memoize((data) =>
  _.chain(data)
    .head()
    .omit('detailId', 'depositRequestId', 'myUuid', 'recordDate', 'recordTime', 'dealerId')
    .keys()
    .value(),
);

export const defaultColumnMapper = _.memoize((col) => ({
  dataField: col,
  text: _.upperCase(col),
  sort: true,
  // align: 'center',
  style: { overflow: 'hidden', textOverflow: 'ellipsis', textAlign: 'center' },
  filter: textFilter({ placeholder: 'Filter..', delay: 500 }),
  formatter: COLUMN_FORMATTERS[col],
  headerStyle: {
    // backgroundColor: "rgb(183, 12, 12, .77)"
  },
}));

export const determineInvoicePaymentAmounts = _.memoize(
  (data, selected) =>
    _.chain(selected)
      .map((contract) => _.find(data, { contract }))
      .map('balanceDue')
      .map(_.parseFloat)
      .value(),
  memFunc,
);

export const determineInvoicePaymentSum = _.memoize(
  (data, selected) => _.sumBy(determineInvoicePaymentAmounts(data, selected), Number),
  memFunc,
);

export const scrollToId = (id) => {
  const element = document.querySelector(id);
  if (element) {
    element.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  }
};

/* eslint-disable max-len */
const EMAIL_REGEX =
  /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;
/* eslint-enable max-len */

export const emailValidation = (value) => !EMAIL_REGEX.test(value);

const DOLLAR_REGEX = /^[0-9]*(\.[0-9]{0,2})?$/;

export const dollarAmountValidation = (value) => (value ? DOLLAR_REGEX.test(value) : false);



// WEBPACK FOOTER //
// ./src/utils/index.js